import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import GoogleMapsWithEditablePolygon from "../../../map";

const MapModal = ({ show, setLocations, locations, onClose ,modalMode }) => {
  console.log(locations, "locations");

  return (
    <Modal
      isOpen={show}
      className="w-100vw"
      size="lg"
      style={{
        maxWidth: "100vw",
        width: "100vw",
        height: "100vh",
        margin: 0,
      }}
      toggle={()=>onClose("map",modalMode)}
    >
      <ModalHeader >
        <h5>اختار الموقع من الخريطة</h5>
      </ModalHeader>
      <ModalBody>
        <GoogleMapsWithEditablePolygon
          existingCoordinates={locations || []}
          setLoactions={setLocations}
        />
      </ModalBody>
      <ModalFooter className="justify-content-start">
     
        <button
          className="btn btn-primary"
          disabled={locations?.length === 0}
          onClick={() => onClose("map",modalMode)}
        >
          تأكيد الموقع علي الخريطة
        </button>
           <button className="btn btn-white"   onClick={() => onClose("map",modalMode)} >
          إلغاء
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default MapModal;
